import { render, staticRenderFns } from "./SbpPaymentBlockIcons.vue?vue&type=template&id=612fa2d4&"
import script from "./SbpPaymentBlockIcons.vue?vue&type=script&lang=js&"
export * from "./SbpPaymentBlockIcons.vue?vue&type=script&lang=js&"
import style0 from "./SbpPaymentBlockIcons.vue?vue&type=style&index=0&lang=postcss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports